import React, { FC, useState } from 'react';
import { FaMinus, FaPlus } from 'react-icons/fa';
import './_styles.incrementer.css';
import { motion } from 'framer-motion';
import fadeIn from '../../animations/fadeIn';

interface IncrementerProps {
  title: string;
  onChange?: (amount: number) => void;
  initialAmount?: number;
  min?: number;
  max?: number;
  delay?: number;
  readonly?: boolean;
}

const Incrementer: FC<IncrementerProps> = ({
  title,
  onChange,
  initialAmount = 0,
  min = 0,
  max = 10,
  delay = 0,
  readonly = false
}) => {
  const [amount, setAmount] = useState(initialAmount);

  const decrement = () => {
    if (amount - 1 < min) {
      return;
    }

    const newAmount = amount - 1;

    if (onChange) {
      onChange(newAmount);
    }

    setAmount(newAmount);
  };

  const increment = () => {
    if (amount + 1 > max) {
      return;
    }

    const newAmount = amount + 1;

    if (onChange) {
      onChange(newAmount);
    }

    setAmount(newAmount);
  };

  return (
    <motion.div
      variants={fadeIn(0.5 + delay)}
      initial='hidden'
      animate='enter'
      exit='exit'
      className='incrementer'
    >
      <p>{title}</p>
      <div className='increment-container'>
        {!readonly && (
          <button onClick={decrement} className='increment-button'>
            <FaMinus />
          </button>
        )}
        <div>
          <p>{amount}</p>
        </div>
        {!readonly && (
          <button onClick={increment} className='increment-button'>
            <FaPlus />
          </button>
        )}
      </div>
    </motion.div>
  );
};

export default Incrementer;
